import { IIdItem, IScheduledItem, ISiteItem } from './resourceParts';

export const ExtractTaskTargetType = {
  Workbook: 'Workbook',
  Datasource: 'Datasource'
};

export const ExtractTaskType = {
  RefreshExtract: 'RefreshExtract',
  IncrementExtract: 'IncrementExtract'
};

export interface IExtractTask extends IIdItem, IScheduledItem, ISiteItem {
  priority: number;
  type: string; // RefreshExtract or IncrementExtract
  lastRunAt?: string; // YYYY-MM-DDThh:mm:ssZ
  runNextAt?: string; // YYYY-MM-DDThh:mm:ssZ
  targetType: string; // Datasource or Workbook
  targetId: string;
  state: string;
}
